module.exports = __webpack_public_path__ + "media/images/new_tab_light_blue-3b14195d34cd0850fee830420d3216ca.svg";